module.exports = __webpack_public_path__ + "img/N8 200X200.bc8e0a81.png";